var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cancer-print"},[_c('div',{staticClass:"genes"},_vm._l((_vm.genes),function(gene,index){return _c('div',{key:index,staticClass:"gene"},[_vm._v(_vm._s(gene))])}),0),_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{ref:"study-canvas"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }